import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import styled from 'vue-styled-components';
import { i18n } from '@/i18n';
import { computed, onMounted, ref } from 'vue';
import Btn from '@/components/input/Btn/SimpleClickBtn.vue';
import router from '@/router';

// style variables

export default /*@__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const TitleWrapper = styled.h2`
  font-size: 3.75rem; /* 60px */
  line-height: 1;
  margin-top: 6rem; /* 128px */
`;

const ContentWrapper = styled.div`
  width: 77%
  margin-top: 3rem; /* 48px */
`;

const TextWrapper = styled.p`
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
`;

const InstructionsWrapper = styled.div`
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
  margin-top: 1rem;
`;

//変数
const t = i18n.t;

//関数
/**
 * ホーム画面に遷移する
 */
const returnHomePage = (): void => {
  router.push('/');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleWrapper, { class: "text-center font-bold" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('404 Not Found')), 1)
      ], undefined, true),
      _: 1
    }),
    _createVNode(ContentWrapper, { class: "mx-auto" }, {
      default: _withCtx(() => [
        _createVNode(TextWrapper, { class: "text-center" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('お探しのページが見つかりませんでした。お手数ですが、ホーム画面から再度アクセスしてください。')), 1)
          ], undefined, true),
          _: 1
        }),
        _createVNode(InstructionsWrapper, { class: "text-center" }, {
          default: _withCtx(() => [
            _createVNode(Btn, {
              "label-text": `>> ${_unref(t)('ホームに戻る')}`,
              "page-address": '/',
              onClick: returnHomePage
            }, null, 8, ["label-text"])
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    })
  ], 64))
}
}

})